// Core
import { useState } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

// Components
import { Button, FieldSelect, FieldText, SectionCard } from "components/AtomsV2";
import { Icon } from "components/ShellV2";

// Utils
import { ALLOCATION_TYPES } from "utils/constants/index";

const SETTLEMENT_SALE_PRICE_TYPES = [
  { value: "INDIVIDUAL", label: "INDIVIDUAL" },
  { value: "AGGREGATOR", label: "AGGREGATOR" },
];

function Settlement({ data, isLoading, onUpdate }) {
  const [original, setOriginal] = useState(data);

  const [methodAllocCoeff, setMethodAllocCoeff] = useState(data.method_alloc_coeff);
  const [lemTradingFee, setLemTradingFee] = useState(data.lem_trading_fee);
  const [settlementSalePriceType, setSettlementSalePriceType] = useState(
    data.settlement_sale_price_type || "INDIVIDUAL"
  );

  const canSave =
    !isLoading &&
    !(
      original.method_alloc_coeff === methodAllocCoeff &&
      original.lem_trading_fee === lemTradingFee &&
      (original.settlement_sale_price_type || "INDIVIDUAL") === settlementSalePriceType
    );
  const { t } = useTranslation(["community"]);

  const onUpdateClicked = async () => {
    if (canSave) {
      const newData = {
        method_alloc_coeff: methodAllocCoeff,
        lem_trading_fee: lemTradingFee,
        settlement_sale_price_type: settlementSalePriceType,
      };
      const success = onUpdate(newData, t("settlement.updated_ok"));

      if (success) {
        setOriginal(newData);
      }
    }
  };

  return (
    <SectionCard
      id="settlement"
      icon="receipt_long"
      title={t("settlement.title")}
      action={
        <Button variant="ghost" size="sm" disabled={!canSave} onClick={onUpdateClicked}>
          <Icon name="save" />
          {t("settlement.update")}
        </Button>
      }
    >
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <FieldSelect
          label={t("settlement.alloc_type")}
          value={methodAllocCoeff}
          options={ALLOCATION_TYPES}
          onChange={setMethodAllocCoeff}
        />
        <FieldText
          label={t("settlement.lem_trading_fee")}
          type="number"
          value={lemTradingFee}
          onChange={(v) => setLemTradingFee(Number(v))}
        />
        <FieldSelect
          label={t("settlement.settlement_sale_price_type")}
          value={settlementSalePriceType}
          options={SETTLEMENT_SALE_PRICE_TYPES}
          onChange={setSettlementSalePriceType}
        />
      </div>
    </SectionCard>
  );
}

Settlement.defaultProps = {
  data: { method_alloc_coeff: "", lem_trading_fee: 0, settlement_sale_price_type: "INDIVIDUAL" },
  isLoading: false,
  onUpdate: () => {},
};

Settlement.propTypes = {
  data: PropTypes.shape({
    method_alloc_coeff: PropTypes.string,
    lem_trading_fee: PropTypes.number,
    settlement_sale_price_type: PropTypes.string,
  }),
  isLoading: PropTypes.bool,
  onUpdate: PropTypes.func,
};

export default Settlement;
